export const EmptyState = ({ title, children }) => {
  return (
    <div className="empty-state">
      {title && <div className="empty-state-title">{title}</div>}
      {children}
    </div>
  );
};
